import { Gender } from "../Gender.js";
import { Locale, type LocalizedString } from "../Locale.js";

export const genderNameMap: Record<Gender, LocalizedString> = {
	[Gender.Male]: {
		[Locale.cs]: "Pánské",
		[Locale.en]: "Male",
	},
	[Gender.Female]: {
		[Locale.cs]: "Dámské",
		[Locale.en]: "Female",
	},
};
